import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBolt';
/** Renders an SVG icon. */
const SvgBolt = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M18.32 4.268a1 1 0 0 1 1.656.949L18.246 13H27a1 1 0 0 1 .68 1.732l-14 13a1 1 0 0 1-1.657-.949L13.753 19H5a1 1 0 0 1-.68-1.732zM7.545 17H15a1 1 0 0 1 .976 1.217l-1.303 5.864 9.781-9.08H17a1 1 0 0 1-.977-1.218l1.303-5.865z"
      />
    </svg>
  );
};
SvgBolt.displayName = displayName;
export default SvgBolt;
